// /frontend/src/api/aiApi.js
import axios from 'axios';

const AI_API_URL = '/api/ai-query';

export const sendAIQuery = async (inputText) => {
  try {
    console.log('Sending query:', inputText); // Add logging
    const response = await axios.post(AI_API_URL, { input_text: inputText });
    console.log('Received response:', response.data); // Add logging
    return response.data;
  } catch (error) {
    console.error('Error querying AI:', error);
    throw error; // Let's throw the error instead of returning an error string
  }
};